import { useCallback } from "react";
import { DEMAND, DEMAND_TYPE, formatDateTime } from "@demandproai/shared";

const useDocxVersioning = ({ caseData } = {}) => {
  const getDocxS3Url = useCallback(({ docxFiles, demandKey }) => {
    const entry = docxFiles?.[demandKey];
    if (!entry) {
      return null;
    }
    if (typeof entry === "string") {
      return entry;
    }
    return entry?.s3UrlPath || null;
  }, []);

  const getDefaultVersionS3Url = useCallback(({ docxFiles = caseData?.docxFiles || {} } = {}) => {
    const medicalChronKey = DEMAND_TYPE?.[DEMAND.Medical_Chronology]?.key;
    const medicalChronPath = getDocxS3Url({ docxFiles, demandKey: medicalChronKey });
    if (medicalChronPath) {
      return medicalChronPath;
    }
    const firstKey = Object.keys(docxFiles).find((key) => key !== "downloads");
    if (!firstKey) {
      return null;
    }
    return getDocxS3Url({ docxFiles, demandKey: firstKey });
  }, [caseData?.docxFiles, getDocxS3Url]);

  const formatVersionLabel = useCallback(({ versionNumber, lastModified, requestedBy }) => {
    const formattedDate = formatDateTime(lastModified);
    const hasValidDate = lastModified && formattedDate !== 'N/A';
    const versionWithDate = hasValidDate
      ? `Ver. ${versionNumber} - ${formattedDate}`
      : `Ver. ${versionNumber}`;
    const requesterFullName = requestedBy
      ? ` · ${requestedBy.firstName} ${requestedBy.lastName}`
      : '';
    return `${versionWithDate}${requesterFullName}`;
  }, []);

  return {
    getDocxS3Url,
    getDefaultVersionS3Url,
    formatVersionLabel
  };
};

export default useDocxVersioning;
